import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../icons/logo-main-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-3280fc35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "prompt-pass"
}
const _hoisted_2 = { class: "pass" }
const _hoisted_3 = {
  key: 0,
  class: "incorrect-password"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "valider", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "files-container"
}
const _hoisted_7 = { class: "download-infos" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Valide jusqu'au: ")
const _hoisted_9 = { class: "your-files" }
const _hoisted_10 = { class: "files" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456zM233.4 374.6C239.6 380.9 247.8 384 256 384s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25c-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32C238.3 0 224 14.33 224 32v242.8L150.6 201.4c-12.49-12.5-32.75-12.5-45.25 0c-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]

import { constants } from "@/compositions/constants";
import axios from "axios";
import { computed, onMounted, Ref, ref } from "vue";
import { useRoute } from "vue-router";
import { DownloadableFile } from "@/classes/DownloadableFile";
import router from "@/router";
import LoadingScreen from "../components/LoadingScreen.vue";
import PasswordInput from "../components/PasswordInput.vue";
import {
  formatDateFromMillis,
  formatSize,
  go_back_home,
} from "@/compositions/functions";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadView',
  setup(__props) {

const data = ref();
const folder = ref("");

const loading = ref(true);
const promptPassword = ref(false);
const show_wrong_pass = ref(false);
const verifying_pass = ref(false);
const submittedPass = ref("");

const total_size = computed(() => {
  if (data.value.files) {
    return data.value.files.reduce((prev, current) => current.size + prev, 0);
  }
  return 0;
});

const validatePass = async () => {
  if (submittedPass.value.length > 0) {
    verifying_pass.value = true;
    // loading.value = true;
    // promptPassword.value = false;
    const body = { folder: folder.value, pass: submittedPass.value };

    const res = await axios
      .post(`${constants.API}/folder`, body)
      .then((res) => {
        // loading.value = false;
        verifying_pass.value = false;
        if (res.status == 200) {
          if (res.data.code == 1) {
            // console.log("wrong pass");
            // loading.value = false;
            // promptPassword.value = true;
            // submittedPass.value = "";
            show_wrong_pass.value = false;
            setTimeout(() => {
              show_wrong_pass.value = true;
            }, 100);
            return;
          }
          promptPassword.value = false;

          // file.uploaded = true;
          // console.log("upload finished");
          // console.log(res.data);

          data.value = res.data;
          sessionStorage.setItem(
            folder.value,
            JSON.stringify(data.value.files)
          );
        }
      });
  }
};

const downloadMultiple = () => {
  const dl_url = "https://transfer.oeilabsolu.ch/api/download/" + folder.value;
  var a = document.createElement("a");
  a.href = dl_url;
  a.onclick = () => {
    setTimeout(() => {
      window.location.reload(), a.remove();
    }, 1000);
  };

  document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

  a.click();
  // a.remove(); //afterwards we remove the element again
  // // window.location.reload();
  // window.location.reload();
};

const downloadSingle = async (url: string, filename: string) => {
  const dl_url = "https://transfer.oeilabsolu.ch/api/download/" + url;

  var a = document.createElement("a");
  a.href = dl_url;
  a.setAttribute("download", filename);
  document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
  a.onclick = () => {
    setTimeout(() => {
      window.location.reload(), a.remove();
    }, 1000);
  };
  a.click(); //afterwards we remove the element again
};

onMounted(async () => {
  const route = useRoute();
  folder.value = route.params.folder as string;

  const f = sessionStorage.getItem(folder.value);

  // files.value = ["invalid folder"];
  const body = { folder: folder.value, pass: submittedPass.value };

  const res = await axios
    .post(`${constants.API}/folder`, body)
    .then((res) => {
      loading.value = false;
      if (res.status == 200) {
        if (res.data.code === 0) {
          router.replace("/error");
          return;
        }
        if (res.data.code == 1) {
          data.value = { title: res.data.title };
          // console.log(res.data);
          //si il faut un mot de passe
          if (f !== null) {
            // console.log(f);
            //on la deja donné donc on recharge les fichiers
            data.value.files = JSON.parse(f);
            data.value.valid_until = res.data.valid_until;
            data.value.remaining_dl = res.data.remaining_dl;
            // console.log(res.data.valid_until);
            return;
          } else {
            //sinon on redemande le mot de passe
            promptPassword.value = true;
            loading.value = false;
            return;
          }
        }
        // file.uploaded = true;
        // console.log("upload finished");
        // console.log(res.data);
        // console.log(res.data);
        data.value = res.data;
      }
    })
    .catch((err) => {
      store.state.dl_error = err.response.data;
      router.replace("/error");
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingScreen, {
          key: 0,
          class: "loading"
        }))
      : _createCommentVNode("", true),
    (promptPassword.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "woah-logo",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(go_back_home)(false)))
          }),
          _createElementVNode("h1", null, "Votre téléchargement - " + _toDisplayString(data.value.title), 1),
          _createElementVNode("div", _hoisted_2, [
            (show_wrong_pass.value)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, " Le mot de passe est incorrect "))
              : _createCommentVNode("", true),
            _createVNode(PasswordInput, {
              onPass_change: _cache[1] || (_cache[1] = (new_pass) => (submittedPass.value = new_pass)),
              onEnter: validatePass
            }),
            _createElementVNode("button", {
              class: _normalizeClass(verifying_pass.value ? 'verify-pass' : ''),
              onClick: validatePass
            }, _hoisted_5, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !promptPassword.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "woah-logo",
            src: _imports_0,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(go_back_home)(false)))
          }),
          _createElementVNode("h1", null, "Votre téléchargement - " + _toDisplayString(data.value.title), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", null, [
              _hoisted_8,
              _createElementVNode("b", null, _toDisplayString(_unref(formatDateFromMillis)(data.value.valid_until)), 1)
            ]),
            _createElementVNode("h3", null, " Téléchargements restant: " + _toDisplayString(data.value.remaining_dl), 1)
          ]),
          _createElementVNode("h2", _hoisted_9, "Vos fichiers (" + _toDisplayString(_unref(formatSize)(_unref(total_size))) + ")", 1),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.files, (file, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "file",
                key: i
              }, [
                _createElementVNode("h3", null, _toDisplayString(file.filename) + " (" + _toDisplayString(_unref(formatSize)(file.size)) + ")", 1),
                _createElementVNode("div", {
                  class: "dl-single",
                  onClick: _withModifiers(($event: any) => (downloadSingle(file.url, file.filename)), ["prevent"])
                }, _hoisted_13, 8, _hoisted_11)
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "button-dl-all",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadMultiple()))
          }, " Télécharger ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})